module.exports = __webpack_public_path__ + "img/UPDATE.3c064464.svg";